/**
 * Locked taxonomy. DO NOT add or remove categories at runtime.
 * Per CLAUDE.md: Australia-only scope. Renames happen via tenants.category_labels,
 * not by editing this file.
 */

export type CourseCategory = 'vocational' | 'higher_education' | 'research' | 'trade';

export const COURSE_CATEGORIES = [
  'vocational',
  'higher_education',
  'research',
  'trade',
] as const satisfies readonly CourseCategory[];

export const DEFAULT_CATEGORY_LABELS: Record<CourseCategory, string> = {
  vocational: 'Vocational courses',
  higher_education: 'Higher education',
  research: 'Research / PhD',
  trade: 'Trade',
};

export const DEFAULT_CATEGORY_ORDER: readonly CourseCategory[] = [
  'vocational',
  'higher_education',
  'research',
  'trade',
] as const;

/**
 * Tabler icon names per category, used by the sidebar.
 * Mirrors docs/06_BRAND_AND_UI.md iconography mapping.
 */
export const CATEGORY_ICONS: Record<CourseCategory, string> = {
  vocational: 'tool',
  higher_education: 'school',
  research: 'microscope',
  trade: 'hammer',
};
